//LL: 20.02.20: my flag  for themeFields.geometryMisc_mergeSeriesByStack => themeFields.coloring_separateColorsToSideBySideStacks
export const MergeSeriesByStack_New = true;

export const themeFields = {
    //LL: Actual Axis:
    axis_ChartAxisField_X: 'widget-chart-var-axis-Actual-ChartAxisField_X',
    axis_ChartAxisField_Y: 'widget-chart-var-Actual-ChartAxisField_Y', //LL: without -axis-, my migration fault
    axis_ChartAxisField_Arr: 'widget-chart-var-Actual-ChartAxisField_Arr', //LL: without -axis-, my migration fault
    themeGroup_ActualAxis: 'widget-chart-group-actualAxis', // in main section
    themeGroup_ActualAxis_main: 'widget-chart-group-actualAxis_main', // in main section
    themeGroup_ActualAxis_auxiliary: 'widget-chart-group-actualAxis_auxiliary', // in main section

    themeSection_Axis_Arguments: 'widget-chart-Axis-Arguments', //LL: inheritable section, inside themeSection_Axis
    themeSection_Axis_Values: 'widget-chart-Axis-Values', //LL: inheritable section, inside themeSection_Axis
    themeSection_Axis_ExtraValues: 'widget-chart-Axis-ExtraValues', //LL: inheritable section, inside themeSection_Axis

    axisBreaks_ActualBreaks: 'widget-chart-var-AxisBreaks-ActualBreaks',
    themeGroup_ActualBreaks: 'widget-chart-group-actualBreaks', // in main section
    axisStrips_ActualStrips: 'widget-chart-var-AxisStrips-ActualStrips',
    themeGroup_ActualStrips: 'widget-chart-group-actualStrips', // in main section
    axisConstantLines_ActualConstantLines: 'widget-chart-var-AxisConstantLines-ActualConstantLines',
    themeGroup_ActualConstantLines: 'widget-chart-group-actualConstantLines', // in main section

    themeGroup_AxisBreaks: 'widget-chart-group-axisBreaks', //LL: inheritable section, inside themeSection_AxisBreaks
    themeGroup_AxisConstantLines: 'widget-chart-group-axisConstantLines', //LL: inheritable section, inside themeSection_AxisConstantLines
    themeGroup_AxisStrips: 'widget-chart-group-axisStrips', //LL: inheritable section, inside themeSection_AxisStrips
    
    //---------------------------------------------------------------------------------------------------

    themeSection_Main: 'widget-chart',

    themeSection_Animation: 'widget-chart-animation',
    animation_enabled: 'widget-chart-var-animation-enabled',
    animation_enabled_resize: 'widget-chart-var-animation-enabled-resize',
    animation_duration: 'widget-chart-var-animation-duration',
    animation_maxPointCount: 'widget-chart-var-animation-maxPointCount',

    themeSection_Warnings: 'widget-chart-warnings',
    warning_emptyData_show: 'widget-chart-var-warning_emptyData_show',
    warning_emptyData_text: 'widget-chart-var-warning_emptyData_text',

    themeGroup_DevExpress_messages: 'widget-chart-group-DevExpress_messages',
    DevExpress_messages_processing_method: 'widget-chart-var-DevExpress_messages_processing_method',
    DevExpress_messages_warnings_console: 'widget-chart-var-DevExpress_warnings_console',
    DevExpress_messages_warnings_screen: 'widget-chart-var-DevExpress_warnings_screen',
    DevExpress_messages_errors_console: 'widget-chart-var-DevExpress_errors_console',
    DevExpress_messages_errors_screen: 'widget-chart-var-DevExpress_errors_screen',
    //DevExpress_messages_warnings: 'widget-chart-var-DevExpress_warnings',
    //DevExpress_messages_errors: 'widget-chart-var-DevExpress_errors',

    themeSection_AdaptiveLayout: 'widget-chart-adaptiveLayout',
    adaptiveLayout_size: 'widget-chart-var-adaptiveLayout_size',
    adaptiveLayout_keepLabelsXY: 'widget-chart-var-adaptiveLayout_keepLabelsXY', // for Pie always false (by default)

    themeSection_Fonts: 'widget-chart-fonts',
    font_inTooltip: 'widget-chart-var-fonts-inTooltip', //LL: as FontBoxField
    font_inPointLabels: 'widget-chart-var-fonts-inPointLabels', //LL: as FontBoxField
    font_inAxisLabels: 'widget-chart-var-fonts-inAxisLabels', //LL: as FontBoxField
    font_inLegend: 'widget-chart-var-fonts-inLegend', //LL: as FontBoxField
    font_inConstLines: 'widget-chart-var-fonts-inConstLines', //LL: as FontBoxField
    font_inStrips: 'widget-chart-var-fonts-inStrips', //LL: as FontBoxField

    //LL: Sections without inheritance, visibility only for Widget level =============

    themeSection_withoutInheritance: 'widget-chart-withoutInheritance',

    external_params: 'widget-chart-external-params', // object include curChartType, types for Axis, etc, some functions?

    //LL: 04.12.19: LEO: "I think you should put Chart Styles in a separate section", "I think they belong better in separate sections"
    themeSection_ColoringAndStyling: 'widget-chart-ColoringAndStyling', // Coloring and Styling
    themeSection_Coloring: 'widget-chart-Coloring',
    themeSection_Styling: 'widget-chart-Styling',

    themeGroup_Coloring: 'widget-chart-group-Coloring',
    coloring_colorAssignment: 'widget-chart-var-coloring-colorAssignment',
    coloring_palette: 'widget-chart-var-coloring-palette',
    coloring_paletteExtensionMode: 'widget-chart-var-coloring-paletteExtensionMode',
    coloring_singleSeriesColor: 'widget-chart-var-coloring-singleSeriesColor',
    coloring_colorMapPriority: 'widget-chart-var-coloring-colorMapPriority', // colorMapPriority (SBS+Stack)
    coloring_applyEntityColorMapping: 'widget-chart-var-coloring-applyEntityColorMapping',
    coloring_separateColorsToSideBySideStacks: 'widget-chart-var-coloring-separateColorsToSideBySideStacks', //LL: reverse to geometryMisc_mergeSeriesByStack
    //LL: Border Color for Bars:
    coloring_borderVisible: 'widget-chart-var-coloring-borderVisible',
    coloring_borderColor: 'widget-chart-var-coloring-borderColor',
    coloring_borderWidth: 'widget-chart-var-coloring-borderWidth',

    themeGroup_Styling: 'widget-chart-group-Styling',
    styling_chartCustomStyles: 'widget-chart-var-styling-chartCustomStyles',

    themeSection_Title: 'widget-chart-Title',
    themeGroup_Title_Font: 'widget-chart-group-Title-Font', //LL: 26.06.25
    themeGroup_Title_subTitle_Font: 'widget-chart-group-Title-subTitle-Font', //LL: 26.06.25
    themeGroup_Title_Position: 'widget-chart-group-Title-Position', //LL: 26.06.25
    title_ownTitle: 'widget-chart-var-title-ownTitle',
    title_subTitle: 'widget-chart-var-title-subTitle',
    title_color: 'widget-chart-var-title-color',
    title_subTitle_color: 'widget-chart-var-title-subTitle-color', //LL: 25.06.25
    title_font: 'widget-chart-var-title-font', //LL: 25.06.25
    title_subTitle_font: 'widget-chart-var-title-subTitle-font', //LL: 25.06.25
    title_subTitle_useOwnFont: 'widget-chart-var-title-subTitle-useOwnFont', //LL: 26.06.25
    title_horizontalAlignment: 'widget-chart-var-title-horizontalAlignment',
    title_verticalAlignment: 'widget-chart-var-title-verticalAlignment',

    // Geometry
    themeSection_Geometry: 'widget-chart-Geometry', 
    themeGroup_GeometryMisc: 'widget-chart-group-GeometryMisc',
    geometryMisc_showPointsInArea: 'widget-chart-var-geometryMisc-showPointsInArea',
    geometryMisc_showPointsInLines: 'widget-chart-var-geometryMisc-showPointsInLines',
    geometryMisc_setStacked: 'widget-chart-var-geometryMisc-setStacked',
    geometryMisc_showEmptyBars: 'widget-chart-var-geometryMisc-showEmptyBars',
    geometryMisc_emptyValuesAsZero: 'widget-chart-var-geometryMisc-emptyValuesAsZero',
    geometryMisc_mergeSeriesByStack: 'widget-chart-var-geometryMisc-mergeSeriesByStack', //LL: reverse to new themeFields.coloring_separateColorsToSideBySideStacks
    geometryMisc_fullStacked: 'widget-chart-var-geometryMisc-fullStacked', 
    geometryMisc_asPolarChart: 'widget-chart-var-geometryMisc-asPolarChart', 

    themeGroup_BarOptions: 'widget-chart-group-BarOptions',
    barOptions_minBarSize: 'widget-chart-var-barOptions-minBarSize',
    barOptions_barPadding: 'widget-chart-var-barOptions-barPadding',
    barOptions_barGroupPadding: 'widget-chart-var-barOptions-barGroupPadding',

    themeGroup_PieOptions: 'widget-chart-group-PieOptions',
    pieOptions_diameter: 'widget-chart-var-pieOptions-diameter',

    // Legend
    themeSection_Legend: 'widget-chart-Legend', 
    //  groups for D3 and notD3
    //  "legendVisible" - common, out of groups

    legend_legendVisible: 'widget-chart-var-legend-legendVisible',
    legend_itemSorting: 'widget-chart-var-legend-itemSorting',

    legend_includeDataQueryIndexIntoNames: 'widget-chart-var-legend-includeDataQueryIndexIntoNames',
    legend_includeAxisNameIntoNames: 'widget-chart-var-legend-includeAxisNameIntoNames',
    legend_includeSbsLabelIntoNames: 'widget-chart-var-legend-includeSbsLabelIntoNames',

    themeGroup_Legend_notD3: 'widget-chart-group-Legend-notD3',
    legend_legendPosition: 'widget-chart-var-legend-legendPosition', // 'Orientation'
    //legend_legendPosition2: 'widget-chart-var-legend-legendPosition2',  // 'Alignment'  old
    legend_legendAlignmentHoriz: 'widget-chart-var-legend-legendAlignmentHoriz', // 'Alignment'  for Horiz
    legend_legendAlignmentVert: 'widget-chart-var-legend-legendAlignmentVert', // 'Alignment'  for Vert
    legend_legendPositionInsideOutside: 'widget-chart-var-legend-legendPositionInsideOutside', // 'Position'
    legend_legendColumnCountHoriz: 'widget-chart-var-legend-legendColumnCountHoriz',
    legend_legendColumnCountVert: 'widget-chart-var-legend-legendColumnCountVert',

    themeGroup_Legend_D3: 'widget-chart-group-Legend-D3',
    legend_legendPosition_D3: 'widget-chart-var-legend-legendPosition-D3', //  D3  d3_legendPosition

    legend_color_fontColor: 'widget-chart-var-legend-color-fontColor',
    legend_color_bgColor: 'widget-chart-var-legend-color-bgColor',

    //legend_text_D3: 'widget-chart-var-legend-text-D3',
    //legend_text_notD3: 'widget-chart-var-legend-text-notD3',

    // Point Labels
    themeSection_PointLabels: 'widget-chart-PointLabels', 

    //  outside groups:  No, default "show" is different for XY and Pie
    //pointLabels_label_show: 'widget-chart-var-pointLabels-show',  // XY, Pie, D3   

    themeGroup_PointLabels_XY: 'widget-chart-group-PointLabels-XY',
    pointLabels_XY_show: 'widget-chart-var-pointLabels-XY-show',
    pointLabels_XY_connectorVisible: 'widget-chart-var-pointLabels-XY-connectorVisible',
    pointLabels_XY_position: 'widget-chart-var-pointLabels-XY-position',
    pointLabels_XY_alignment: 'widget-chart-var-pointLabels-XY-alignment',
    pointLabels_XY_rotationAngle: 'widget-chart-var-pointLabels-XY-rotationAngle',
    pointLabels_XY_verticalOffset: 'widget-chart-var-pointLabels-XY-verticalOffset',
    pointLabels_XY_horizontalOffset: 'widget-chart-var-pointLabels-XY-horizontalOffset',
    pointLabels_XY_resolveLabelOverlapping: 'widget-chart-var-pointLabels-XY-resolveLabelOverlapping',

    themeGroup_PointLabels_Pie: 'widget-chart-group-PointLabels-Pie',
    pointLabels_Pie_show: 'widget-chart-var-pointLabels-Pie-show',
    pointLabels_Pie_connectorVisible: 'widget-chart-var-pointLabels-Pie-connectorVisible',
    pointLabels_Pie_showPieLabelsThreshold: 'widget-chart-var-pointLabels-Pie-showPieLabelsThreshold',
    pointLabels_Pie_position: 'widget-chart-var-pointLabels-Pie-position',
    pointLabels_Pie_rotationAngle: 'widget-chart-var-pointLabels-Pie-rotationAngle',
    pointLabels_Pie_radialOffset: 'widget-chart-var-pointLabels-Pie-radialOffset',
    pointLabels_Pie_resolveLabelOverlapping: 'widget-chart-var-pointLabels-Pie-resolveLabelOverlapping',
    pointLabels_Pie_useDefaultFontColor: 'widget-chart-var-pointLabels-Pie-useDefaultFontColor',
    pointLabels_Pie_fontColor: 'widget-chart-var-pointLabels-Pie-fontColor',
    pointLabels_Pie_addSeriesName: 'widget-chart-var-pointLabels-Pie-addSeriesName', // used when Ys > 1

    themeGroup_PointLabels_Pie_Color: 'widget-chart-group-PointLabels-Pie-Color',
    pointLabels_Pie_backgroundColor_default: 'widget-chart-var-pointLabels-Pie-backgroundColor_default',
    pointLabels_Pie_backgroundColor: 'widget-chart-var-pointLabels-Pie-backgroundColor',
    pointLabels_Pie_borderVisible: 'widget-chart-var-pointLabels-Pie-borderVisible',
    pointLabels_Pie_borderColor: 'widget-chart-var-pointLabels-Pie-borderColor',

    themeGroup_PointLabels_D3: 'widget-chart-group-PointLabels-D3',
    pointLabels_D3_show: 'widget-chart-var-pointLabels-D3-show', 
    pointLabels_D3_labelInOneLine: 'widget-chart-var-pointLabels-D3-labelInOneLine',
    pointLabels_D3_labelHideRadius: 'widget-chart-var-pointLabels-D3-labelHideRadius', // bubbleMap
    pointLabels_D3_labelHideSize: 'widget-chart-var-pointLabels-D3-labelHideSize', //    areaMap
    pointLabels_D3_labelPositionHoriz: 'widget-chart-var-pointLabels-D3-labelPositionHoriz', //     areaMap
    pointLabels_D3_labelPositionVert: 'widget-chart-var-pointLabels-D3-labelPositionVert', //     areaMap
    pointLabels_D3_labelColor: 'widget-chart-var-pointLabels-D3-labelColor',

    themeGroup_PointLabels_Color: 'widget-chart-group-PointLabels-Color',
    pointLabels_color_useDefaultColor: 'widget-chart-var-pointLabels-color-useDefaultColor',
    pointLabels_color_fontColor: 'widget-chart-var-pointLabels-color-fontColor',
    pointLabels_color_backgroundColor: 'widget-chart-var-pointLabels-color-backgroundColor',
    pointLabels_color_borderVisible: 'widget-chart-var-pointLabels-color-borderVisible',
    pointLabels_color_borderColor: 'widget-chart-var-pointLabels-color-borderColor',

    themeGroup_PointLabels_onlyOneLabelPerStack: 'widget-chart-group-PointLabels-onlyOneLabelPerStack',
    pointLabels_onlyOneLabelPerStack_enable: 'widget-chart-var-pointLabels-onlyOneLabelPerStack-enable',
    pointLabels_onlyOneLabelPerStack_useDefaultColor:
        'widget-chart-var-pointLabels-onlyOneLabelPerStack-useDefaultColor',
    pointLabels_onlyOneLabelPerStack_fontColor: 'widget-chart-var-pointLabels-onlyOneLabelPerStack-fontColor',
    pointLabels_onlyOneLabelPerStack_backgroundColor: 'widget-chart-var-pointLabels-onlyOneLabelPerStack-backColor',

    themeGroup_PointLabels_ShowInLabel: 'widget-chart-group-PointLabels-ShowInLabel',
    pointLabels_showInLabel_standard: 'widget-chart-var-pointLabels-showInLabel-standard',
    pointLabels_showInLabel_bubble: 'widget-chart-var-pointLabels-showInLabel-bubble',
    pointLabels_showInLabel_range: 'widget-chart-var-pointLabels-showInLabel-range',
    pointLabels_showInLabel_fiscal: 'widget-chart-var-pointLabels-showInLabel-fiscal',
    pointLabels_showInLabel_pie: 'widget-chart-var-pointLabels-showInLabel-pie',
    pointLabels_showInLabel_d3: 'widget-chart-var-pointLabels-showInLabel-d3',
    pointLabels_showInLabel_pie_addValueDataLabel: 'widget-chart-var-pointLabels-showInLabel-pie-addValueDataLabel',
    pointLabels_showInLabel_standard_addValueDataLabel:
        'widget-chart-var-pointLabels-showInLabel-standard-addValueDataLabel',
    pointLabels_showInLabel_bubble_addValueDataLabel:
        'widget-chart-var-pointLabels-showInLabel-bubble-addValueDataLabel',

    //LL: SubTitles SBT
    themeGroup_PointLabels_SubTitles: 'widget-chart-group-PointLabels-SubTitles',
    pointLabels_subTitles_fontColor: 'widget-chart-var-pointLabels-subTitles-fontColor',
    pointLabels_subTitles_backgroundColor: 'widget-chart-var-pointLabels-subTitles-backgroundColor',
    pointLabels_subTitles_borderVisible: 'widget-chart-var-pointLabels-subTitles-borderVisible',
    pointLabels_subTitles_borderColor: 'widget-chart-var-pointLabels-subTitles-borderColor',
    pointLabels_subTitles_font: 'widget-chart-var-pointLabels-subTitles-font',
    pointLabels_subTitles_width: 'widget-chart-var-pointLabels-subTitles-width',
    pointLabels_subTitles_height: 'widget-chart-var-pointLabels-subTitles-height',
    pointLabels_subTitles_paddingLeftRight: 'widget-chart-var-pointLabels-subTitles-paddingLeftRight',
    pointLabels_subTitles_paddingTopBottom: 'widget-chart-var-pointLabels-subTitles-paddingTopBottom',
    //pointLabels_subTitles_textOverflow: 'widget-chart-var-pointLabels-subTitles-textOverflow',
    pointLabels_subTitles_adjustTop: 'widget-chart-var-pointLabels-subTitles-adjustTop', //LL: for offsetY
    pointLabels_subTitles_argumentAxisLabelsIndentation: 'widget-chart-var-pointLabels-subTitles-argumentAxisLabelIndentation',
    //   BarWidth - not defined now ????  (set for each Series ???)

    // Tooltips
    themeSection_Tooltips: 'widget-chart-Tooltips', 
    //  no groups
    tooltips_enabled: 'widget-chart-var-tooltips-enabled',
    tooltips_backcolor: 'widget-chart-var-tooltips-backcolor',
    tooltips_fontColor: 'widget-chart-var-tooltips-fontColor',
    tooltips_shared: 'widget-chart-var-tooltips-shared',
    tooltips_showTotal: 'widget-chart-var-tooltips-showTotal',
    tooltips_showPercent: 'widget-chart-var-tooltips-showPercent',

    //LL: Horiz/Vert, not Y/X - because of "rotated"
    themeSection_Crosshair: 'widget-chart-Crosshair',
    //  no groups
    crosshair_enabled: 'widget-chart-var-crosshair-enabled',
    crosshair_visible_Vert: 'widget-chart-var-crosshair-visible-Vert',
    crosshair_visible_Horiz: 'widget-chart-var-crosshair-visible-Horiz',
    crosshair_line_color: 'widget-chart-var-crosshair-line-color',
    crosshair_line_width: 'widget-chart-var-crosshair-line-width',
    crosshair_line_dashStyle: 'widget-chart-var-crosshair-line-dashStyle',
    crosshair_backcolor: 'widget-chart-var-crosshair-backcolor',

    themeGroup_crosshairLabels: 'widget-chart-group-crosshairLabels',
    crosshair_labels_visible_Vert: 'widget-chart-var-crosshair-labels-visible-Vert',
    crosshair_labels_visible_Horiz: 'widget-chart-var-crosshair-labels-visible-Horiz',
    crosshair_labels_back_color: 'widget-chart-var-crosshair-labels-back-color',
    crosshair_labels_font_color: 'widget-chart-var-crosshair-labels-font-color',

    // Zooming and Scrolling
    themeSection_ZoomingAndScrolling: 'widget-chart-ZoomingAndScrolling', 

    themeGroup_ScrollBar_old: 'widget-chart-group-ScrollBarOld',
    scrollBarOld_scrollOrZoom_show: 'widget-chart-var-scrollBarOld-scrollOrZoom-show',
    scrollBarOld_scrollOrZoom_adjustScale: 'widget-chart-var-scrollBarOld-scrollOrZoom-adjustScale',
    scrollBarOld_scrollOrZoom_rangeSelector_position:
        'widget-chart-var-scrollBarOld-scrollOrZoom-rangeSelector-position',
    scrollBarOld_scrollOrZoom_rangeSelector_chartType:
        'widget-chart-var-scrollBarOld-scrollOrZoom-rangeSelector-chartType',

    themeGroup_ZoomingAndScrolling_new: 'widget-chart-group-ZoomingAndScrolling',
    zoomingAndScrollingNew_zoom_Arguments: 'widget-chart-var-zoomingAndScrollingNew-zoom-Arguments',
    zoomingAndScrollingNew_scroll_Arguments: 'widget-chart-var-zoomingAndScrollingNew-scroll-Arguments',
    zoomingAndScrollingNew_zoom_Values: 'widget-chart-var-zoomingAndScrollingNew-zoom-Values',
    zoomingAndScrollingNew_scroll_Values: 'widget-chart-var-zoomingAndScrollingNew-scroll-Values',
    zoomingAndScrollingNew_scrollBar_show: 'widget-chart-var-zoomingAndScrollingNew-scrollBar-show',
    zoomingAndScrollingNew_scrollBar_position: 'widget-chart-var-zoomingAndScrollingNew-scrollBar-position',

    // Axis
    themeSection_Axis: 'widget-chart-Axis', 
    themeGroup_HorizontalAxis: 'widget-chart-group-horizontalAxis', //LL group for horizontalAxis
    axis_rotateXY: 'widget-chart-var-axis-rotateXY', 
    axis_horizontalAxis_overlappingBehavior: 'widget-chart-var-axis-horizontalAxis-overlappingBehavior', //  Horizontal Axis
    axis_horizontalAxis_argumentAngle: 'widget-chart-var-axis-horizontalAxis-argumentAngle', //  Horizontal Axis
    axis_horizontalAxis_displayMode: 'widget-chart-var-axis-horizontalAxis-displayMode',
    axis_synchronizeMultiAxes: 'widget-chart-var-axis-synchronizeMultiAxes',
    axis_axisColor: 'widget-chart-var-axis-axisColor',
    axis_seriesColorAux: 'widget-chart-var-axis-seriesColorAux',
    axis_axisLabelColor: 'widget-chart-var-axis-axisLabelColor',

    axis_axisActualTry: 'widget-chart-var-axis-actualTry',

    themeGroup_AxisList: 'widget-chart-group-axisList',
    axis_axisList: 'widget-chart-var-axis-axisList', //  array

    // Axis Strips
    themeSection_AxisStrips: 'widget-chart-AxisStrips', 
    //  no groups
    axisStrips_color: 'widget-chart-var-axisStrips-color', //  inside ChartStripsField  and invisible axisStrips_colorDefault (not used now)
    axisStrips_fontColor: 'widget-chart-var-axisStrips-fontColor', //  inside ChartStripsField

    //axisStrips_labelAlignmentVert: 'widget-chart-var-axisStrips-labelAlignmentVert',  //  inside ChartStripsField
    //axisStrips_labelAlignmentHoriz: 'widget-chart-var-axisStrips-labelAlignmentHoriz',  //  inside ChartStripsField
    //LL: differ fields for X and Y:
    axisStrips_labelAlignmentVert_X: 'widget-chart-var-axisStrips-labelAlignmentVert_X',
    axisStrips_labelAlignmentHoriz_X: 'widget-chart-var-axisStrips-labelAlignmentHoriz_X',
    axisStrips_labelAlignmentVert_Y: 'widget-chart-var-axisStrips-labelAlignmentVert_Y',
    axisStrips_labelAlignmentHoriz_Y: 'widget-chart-var-axisStrips-labelAlignmentHoriz_Y',

    themeGroup_AxisStripList: 'widget-chart-group-axisStripList',
    axisStrips_stripList: 'widget-chart-var-axisStrips-stripList', // array

    // Axis Constant Lines
    themeSection_AxisConstantLines: 'widget-chart-AxisConstantLines', 
    //  no groups
    axisConstantLines_color: 'widget-chart-var-axisConstantLines-color', //  inside ChartConstantLinesField
    axisConstantLines_fontColor: 'widget-chart-var-axisConstantLines-fontColor', //  inside ChartConstantLinesField

    //axisConstantLines_labelAlignmentVert: 'widget-chart-var-axisConstantLines-labelAlignmentVert',  //  inside ChartConstantLinesField
    //axisConstantLines_labelAlignmentHoriz: 'widget-chart-var-axisConstantLines-labelAlignmentHoriz',  //  inside ChartConstantLinesField
    //LL: differ fields for X and Y:
    axisConstantLines_labelAlignmentVert_X: 'widget-chart-var-axisConstantLines-labelAlignmentVert_X',
    axisConstantLines_labelAlignmentHoriz_X: 'widget-chart-var-axisConstantLines-labelAlignmentHoriz_X',
    axisConstantLines_labelAlignmentVert_Y: 'widget-chart-var-axisConstantLines-labelAlignmentVert_Y',
    axisConstantLines_labelAlignmentHoriz_Y: 'widget-chart-var-axisConstantLines-labelAlignmentHoriz_Y',

    axisConstantLines_labelPosition: 'widget-chart-var-axisConstantLines-labelPosition', //  inside ChartConstantLinesField
    axisConstantLines_width: 'widget-chart-var-axisConstantLines-width', //  inside ChartConstantLinesField
    axisConstantLines_dashStyle: 'widget-chart-var-axisConstantLines-dashStyle', //  inside ChartConstantLinesField

    themeGroup_AxisConstantLineList: 'widget-chart-group-axisConstantLineList',
    axisConstantLines_constantLineList: 'widget-chart-var-axisConstantLines-constantLineList', // array

    // AxisBreaks
    themeSection_AxisBreaks: 'widget-chart-AxisBreaks',
    //  no groups
    //LL: commented, not used anywhere:
    //axisBreaks_autoEnabled: 'widget-chart-var-axisBreaks-autoEnabled',  //  inside ChartAxisField
    //axisBreaks_autoMaxCount: 'widget-chart-var-axisBreaks-autoMaxCount',  //  inside ChartAxisField
    //axisBreaks_lineStyle: 'widget-chart-var-axisBreaks-lineStyle',  //  inside ChartAxisField
    //axisBreaks_width: 'widget-chart-var-axisBreaks-width',  //  inside ChartAxisField
    axisBreaks_color: 'widget-chart-var-axisBreaks-color' //  inside ChartAxisField
};

export const themeFieldsDefaults = {
    animation_enabled_resize: true,
    animation_enabled: true,
    animation_duration: 500,
    animation_maxPointCount: 300,

    warning_emptyData_text: 'NO DATA AVAILABLE',

    tooltips_showTotal: false,
    tooltips_showPercent: false
};
